import React from 'react'
import { Link } from 'react-router-dom'

import {
  Box,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery
} from '@mui/material'

import SettingsIcon from '@mui/icons-material/Settings'
import HomeIcon from '@mui/icons-material/Home'
import QueueMusicIcon from '@mui/icons-material/QueueMusic'

const ProfileSidebar = ({ page }) => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <>
      {matches && <Box backgroundColor='#fff' sx={{ borderRight: 1, borderColor: 'divider', height: '100vh', width: 350, mr: 5 }}>
        <Divider sx={{ mt: 2 }} />
        <Link to='/profile' style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItem disablePadding>
            <ListItemButton selected={page === 1} sx={{ p: 3 }}>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText>Home</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Divider />

        <Link to='/profile/playlists' style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItem disablePadding>
            <ListItemButton selected={page === 2} sx={{ p: 3 }}>
              <ListItemIcon>
                <QueueMusicIcon />
              </ListItemIcon>
              <ListItemText>Playlists</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Divider />

        <Link to='/profile/settings' style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItem disablePadding>
            <ListItemButton selected={page === 3} sx={{ p: 3 }}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText>Settings</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Divider />
      </Box>}
    </>
  )
}

export default ProfileSidebar